import Input, { info, style, validity } from "element/input";
import attributeChanged from "standard/attributeChanged";
import connected from "standard/connected";
import define from "standard/define";
import __ from "standard/dunder";
import * as f from "standard/f";
import joinCut from "standard/joinCut";
import on from "standard/on";
import onInvalid from "standard/onInvalid";
import overload from "standard/overload";
import paint from "standard/paint";
import repaint from "standard/repaint";
import trait from "standard/trait";
import pattern from "./pattern";

@define("m-email")
class Email extends Input {
  #supportText = "";
  #validity = validity.VALID;
  #value = "";

  static get observedAttributes() {
    return ["value"];
  }

  @attributeChanged("value")
  @repaint
  changeValue(value) {
    this.#value = value;
    return this;
  }

  @connected
  @paint
  [trait.template]() {
    return `
      <div class='${style.input__container}'>
        <label class='${style.input__label}' ${this.#validity} for='email'>E-mail *</label>
        <input class='${style.input}' ${
          this.#validity
        } id='email' name='email' type='email' value='${this.#value}' required />
        <span class='${style.input__supporting}' ${this.#validity}>
          ${info()}
          ${this.#supportText}
        </span>
      </div>
    `;
  }

  @on.change("input")
  @joinCut(trait.check)
  [trait.onChange](event) {
    this.#value = event.target.value;
    return this;
  }

  @onInvalid
  @repaint
  [trait.check]() {
    if (f.isEmpty(this)) {
      this.#validity = validity.INVALID;
      this.#supportText = "E-mail é obrigatório";
      return this;
    }

    if (f.not.test(pattern, this)) {
      this.#validity = validity.INVALID;
      this.#supportText = "E-mail inválido";
      return this;
    }

    this.#validity = validity.VALID;
    this.#supportText = "";
    return this;
  }

  @overload(__.test__)
  [__.isEmpty__]() {
    return this.#value;
  }
}

export default Email;
